import { FlexSpinner } from 'components'
import { Box } from 'grid'
import {
  DefaultButton,
  Dialog,
  DialogType,
  IDialogProps,
  PrimaryButton,
  Stack,
} from 'office-ui-fabric-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'theme'

export type YesNoDialogProps = Omit<
  IDialogProps,
  'onDismiss' | 'modalProps'
> & {
  onConfirm: (ev?: React.MouseEvent<HTMLButtonElement>) => any
  onDismiss: (ev?: React.MouseEvent<HTMLButtonElement>) => any
  yesButtonText?: string
  noButtonText?: string
  isLoading?: boolean
}

export const YesNoDialog: React.FunctionComponent<YesNoDialogProps> = ({
  dialogContentProps,
  onConfirm,
  onDismiss,
  yesButtonText,
  noButtonText,
  isLoading = false,
  children,
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Dialog
      dialogContentProps={{
        type: DialogType.normal,
        ...dialogContentProps,
      }}
      {...props}
      modalProps={{
        styles: { main: { maxWidth: 500 } },
      }}
      onDismiss={onDismiss}
    >
      <FlexSpinner loading={isLoading}>
        <>
          {children}
          <Box mt={2}>
            <Stack
              tokens={{ childrenGap: theme.space![1] }}
              horizontal={true}
              horizontalAlign="end"
            >
              <Stack.Item>
                <PrimaryButton onClick={onConfirm as any}>
                  {yesButtonText || t('action.yes')}
                </PrimaryButton>
              </Stack.Item>
              <Stack.Item>
                <DefaultButton onClick={onDismiss as any}>
                  {noButtonText || t('action.no')}
                </DefaultButton>
              </Stack.Item>
            </Stack>
          </Box>
        </>
      </FlexSpinner>
    </Dialog>
  )
}

export default YesNoDialog
